interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
  title?: string;
  ariaLabel?: string;
  variant: 'filled' | 'outlined';
}

export const HelpCircle = ({ color, ariaLabel, className, title, role, variant, ...rest }: Props) => {
  const selectedColor = color || '#017ea1';

  const filledPath = (
    <path
      d="M 12,24 C 18.62736,24 24,18.62736 24,12 24,5.3725811 18.62736,0 12,0 5.3725792,0 0,5.3725811 0,12 0,18.62736 5.3725792,24 12,24 Z M 11.99908,6 C 11.99956,6 12,6 12,7.2 12,6 12.000596,6 12.00092,6 h 0.0011 l 0.0022,1.09e-5 0.006,3.71e-5 0.01499,1.789e-4 c 0.01034,1.811e-4 0.0248,4.931e-4 0.0407,0.00102 0.03181,0.00105 0.07268,0.00296 0.121681,0.00653 0.0976,0.007 0.229076,0.020321 0.383635,0.04609 0.3036,0.050596 0.726721,0.1540321 1.16448,0.3728519 0.44232,0.2211838 0.92112,0.5717883 1.286764,1.1201758 0.370559,0.555888 0.576479,1.2431645 0.576479,2.0531405 0,0.8167199 -0.208922,1.4906399 -0.5604,2.0470799 -0.339482,0.53748 -0.774122,0.903843 -1.1196,1.162921 -0.116897,0.08774 -0.2448,0.178208 -0.350042,0.252608 v 0 0 l -1.18e-4,1.13e-4 c -0.04129,0.02913 -0.0791,0.05586 -0.111296,0.07909 -0.123167,0.08837 -0.202489,0.149283 -0.258409,0.198835 V 14.4 c 0,0.662768 -0.537238,1.2 -1.199999,1.2 -0.662639,0 -1.2,-0.537232 -1.2,-1.2 v -1.2 c 0,-0.774115 0.415321,-1.296 0.764161,-1.6158 0.1686,-0.15456 0.34896,-0.28764 0.4962,-0.39312 0.0576,-0.04128 0.109016,-0.07776 0.157558,-0.111961 l 2.4e-4,-1.2e-4 c 0.09149,-0.0648 0.172178,-0.12168 0.261813,-0.189 0.254825,-0.19092 0.420185,-0.34968 0.530719,-0.52452 C 13.108325,10.20936 13.199301,9.98328 13.199301,9.6 c 0,-0.390024 -0.09391,-0.60276 -0.173395,-0.7218592 C 12.942004,8.751528 12.820912,8.6521328 12.663232,8.5733168 12.50088,8.492136 12.324,8.445576 12.1776,8.421168 12.107293,8.4094439 12.051247,8.4040453 12.01752,8.4016324 l -0.01753,-0.00113 -2.4e-4,1.1e-5 c -0.0185,0.00105 -0.0527,0.00342 -0.0984,0.00912 -0.09391,0.011637 -0.2232,0.035107 -0.360352,0.08024 C 11.257072,8.5832534 11.045028,8.730106 10.92899,8.953426 10.62324,9.5415248 9.8988,9.7704 9.3107147,9.4647248 8.7226912,9.159048 8.4938032,8.4345472 8.79948,7.846512 9.3072,6.869832 10.16304,6.416688 10.791,6.210096 11.10984,6.1052287 11.397478,6.053712 11.606516,6.02784 c 0.105705,-0.013076 0.194524,-0.02 0.261244,-0.02368 0.0335,-0.00187 0.06159,-0.00287 0.0838,-0.00338 l 0.0288,-5.637e-4 0.0101,-1.083e-4 0.0048,-1.18e-5 0.0017,-1.22e-5 z M 13.2,18 c 0,0.662768 -0.537232,1.2 -1.2,1.2 -0.662759,0 -1.2,-0.537232 -1.2,-1.2 0,-0.662752 0.537241,-1.2 1.2,-1.2 0.662768,0 1.2,0.537248 1.2,1.2 z"
      fill={selectedColor}
    />
  );

  const outlinedPath = (
    <path
      d="M 12.000001,14.370402 V 13.185157 C 12.000001,12 14.370313,12 14.370313,9.6295966 c 0,-2.370333 -2.370312,-2.370333 -2.370312,-2.370333 0,0 -1.493245,0 -2.1093312,1.185181 m 2.1211482,9.4815134 h -0.02365 M 22.666667,12 c 0,5.891018 -4.775642,10.666666 -10.666666,10.666666 C 6.1089604,22.666666 1.3333331,17.891018 1.3333331,12 c 0,-5.891041 4.7756273,-10.6666669 10.6666679,-10.6666669 5.891024,0 10.666666,4.7756259 10.666666,10.6666669 z"
      stroke={selectedColor}
      strokeWidth="2.66666627"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  );

  return (
    <svg
      className={className}
      aria-label={ariaLabel}
      aria-hidden={!ariaLabel}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={role}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...rest}
    >
      {title && <title>{title}</title>}
      {variant === 'outlined' ? outlinedPath : filledPath}
    </svg>
  );
};
